export const linearGradient = [
  [0, [57, 103, 254]],
  [27.08, [0, 138, 168]],
  [51.56, [123, 195, 66]],
  [76.04, [255, 179, 0]],
  [100, [244, 81, 30]]
];